export default __webpack_public_path__ + "static/media/tlp.82b71a0f.png";